import { useState } from 'react';
import type { IPatientContact } from '../../interfaces/patientContact';
import { fetchJson } from '../../../store/fetch';
import { translateKey } from '../../../translate';
import { ConfirmationModal } from '../../elements/modals/ConfirmationModal';
import { PatientContactItemAddEdit } from './PatientContactItemAddEdit';
import { PatientContactItemRead } from './PatientContactItemRead';

interface IPatientContactItemProps {
    canUpdate?: boolean;
    contactItem: IPatientContact;
    episodeCategoryId: string;
    onSave: () => Promise<void>;
    onUpdate: () => Promise<void>;
    patientId: string;
}

export function PatientContactItem(props: IPatientContactItemProps) {
    const [isEditing, setIsEditing] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <>
            {isEditing ? (
                <PatientContactItemAddEdit
                    contact={props.contactItem}
                    episodeCategoryId={props.episodeCategoryId}
                    formId="newPatientContact"
                    isEditing={isEditing}
                    onCancel={() => {
                        collapseForm();
                    }}
                    onSave={async () => {
                        await props.onSave();
                        collapseForm();
                    }}
                    onUpdate={async () => {
                        await props.onUpdate();
                        collapseForm();
                    }}
                    patientId={props.patientId}
                />
            ) : (
                <PatientContactItemRead
                    contact={props.contactItem}
                    isExpanded={isExpanded}
                    onCanUpdate={props.canUpdate ? handleOnCanUpdate : undefined}
                    onDelete={() => {
                        setIsDeleting(true);
                    }}
                    onUpdate={() => {
                        setIsEditing(true);
                    }}
                />
            )}
            <ConfirmationModal
                handleNo={() => {
                    setIsDeleting(false);
                }}
                handleYes={() => {
                    deletePatientContact();
                }}
                isOpen={isDeleting}
                question={translateKey('request.deleteContactModalText')}
                title={translateKey('request.deleteContactModalTitle')}
            />
        </>
    );

    async function deletePatientContact() {
        const url = `/api/outpatientClinic/patientContacts/${props.contactItem.id}`;
        await fetchJson(url, 'DELETE', {});
        await props.onUpdate();
    }

    function collapseForm() {
        setIsEditing(false);
        setIsExpanded(false);
    }

    function handleOnCanUpdate() {
        setIsExpanded(!isExpanded);
    }
}
